import { render, staticRenderFns } from "./MovieItemListGrid.vue?vue&type=template&id=2aff7ce7&scoped=true&"
import script from "./MovieItemListGrid.vue?vue&type=script&lang=js&"
export * from "./MovieItemListGrid.vue?vue&type=script&lang=js&"
import style0 from "./MovieItemListGrid.vue?vue&type=style&index=0&id=2aff7ce7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff7ce7",
  null
  
)

export default component.exports